enum KeyCode {
  esc = 27
}

export default KeyCode
